import IConfirmDialog = angular.material.IConfirmDialog;
require('./users.less');
import {LoDashStatic} from "lodash";
import IDialogService = angular.material.IDialogService;
const _ = <LoDashStatic> require('lodash');

export interface IOValues {
    output:string,
    input:string
}

class UsersController {
    allUsers:Array<any>;
    authDef:Array<IOValues> = [];
    allAuthorities:Array<any> = [];
    title:string= "Brukere";
    deleteIcon = {
        name:'delete',
        tooltip:'Slett bruker',
        functionCall:(event,user)=> this.deleteUserConfirmation(event, user)
    };
    printIcon = {
        name:'print',
        tooltip:'Sett printere',
        functionCall:(event,user)=> this.setPrinterInformation(event, user)
    };
    tableDefinition = {
        settings: {
            editFunction:(event, order)=> this.handleUser(event, order),
            title: "Brukeradministrasjon",
            promise: null
        },
        columns:[
            {title: "Brukernavn", name: "username"},
            {title: "Grupper", name: "authorities", type:"array", outputDef:this.authDef},
            {title: "Navn", name: "fullname"},
            {title: "Mobil", name: "phonenumber"},
            {title: "Epost", name: "email"},
            {title: "", icon: this.printIcon, cellClass:'width-of-delete-cell'},
            {title: "", icon: this.deleteIcon, cellClass:'width-of-delete-cell'}
        ]
    };

    constructor(private toastService, private Users, private Authorities, private $mdDialog: IDialogService, private userService ) {
        this.getUsers();
        this.getAuthorities();
    }

    getUsers(){
        this.tableDefinition.settings.promise = this.Users.getUsers().$promise.then(
            (users)=>{
                this.allUsers =users;
            },
            (error)=> this.sendError(error)
        );
    }

    deleteUserConfirmation(event, user){
        if(this.userService.userDetails.username === user.username){
            this.toastService.showSimpleToast("Du kan ikke slette deg selv!", 3000);
        }
        else{
            var confirm = this.$mdDialog.confirm()
                .title('Bekreft sletting av bruker')
                .textContent('Slette bruker ' + user.fullname)
                .ariaLabel('jaja')
                .targetEvent(event)
                .ok("Slett")
                .cancel('Avbryt');
            this.$mdDialog.show(confirm).then(() => {
                this.deleteUser(user);
            }, () => {});
        }
    }

    setPrinterInformation(event, user){
        var vm = this;
        this.$mdDialog.show({
            template: '<rkc-printer-selection  modal-instance="c.modalInstance" original-user="c.user"></rkc-printer-selection>',
            controllerAs:'c',
            controller: <any>[ '$mdDialog', function ($mdDialog) {
                this.modalInstance = $mdDialog;
                this.user = user;
            }],
            targetEvent: event,
            clickOutsideToClose: true
        })
            .then(function(answer) {
                vm.getUsers();
            }, function() {
            });
    }

    deleteUser(user){
        this.Users.deleteUser({username:user.username}).$promise.then(
            ()=>{
                this.toastService.showSimpleToast("Brukeren har blitt slettet!", 3000);
                this.getUsers();
            },
            (error)=> this.sendError(error)
        );
    }
    handleUser(event, user){
        var vm = this;

        this.$mdDialog.show({
            template: '<rkc-user-handling  modal-instance="c.modalInstance" original-user="c.user" all-authorities="c.allAuthorities" auth-def="c.authDef"></rkc-user-handling>',
            controllerAs:'c',
            controller: <any>[ '$mdDialog', function ($mdDialog) {
                this.modalInstance = $mdDialog;
                this.user = user;
                this.allAuthorities = vm.allAuthorities;
                this.authDef = vm.authDef;
            }],
            targetEvent: event,
            clickOutsideToClose: true
        })
            .then(function(answer) {
                vm.getUsers();
            }, function() {
            });
    }

    getAuthorities(){
        this.Authorities.getAuthorities().$promise.then(
            (allAuthorities)=>{
                this.allAuthorities = allAuthorities;
                _.forEach(allAuthorities, (auth)=>{
                    this.authDef.push({output:auth.description, input:auth.name});
                });
            },
            (error)=> this.sendError(error)
        );
    }

    sendError(error){
        this.toastService.parseError(error);
    }
}

class UsersOptions implements ng.IComponentOptions {
    controller = 'rkcUsersController';
    controllerAs = "c";
    template: any = require('./users.html');
}

rkcApp.controller("rkcUsersController", ['toastService','Users','Authorities','$mdDialog','userService',
    function(toastService, Users, Authorities, $mdDialog,userService){
        return new UsersController(toastService, Users, Authorities, $mdDialog, userService);
    }])
    .component("rkcUsers", new UsersOptions())
;


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/users/users.ts
 **/